(function () {
  const FREE_SHIPPING_THRESHOLD_CENTS = 5000;

  const getVariantsForRoot = (root) => {
    const productId = root?.dataset?.productId;
    if (!productId || !window.__productVariants) return [];

    const variants = window.__productVariants[productId];
    return Array.isArray(variants) ? variants : [];
  };

  const getVariantById = (root, variantId) => {
    if (!variantId) return null;

    return (
      getVariantsForRoot(root).find(
        (variant) => String(variant.id) === String(variantId)
      ) || null
    );
  };

  const resolveCurrentVariant = (root, passedVariant) => {
    if (passedVariant && passedVariant.id) return passedVariant;

    const variantInput = root?.querySelector('input[name="id"]');
    const selectedVariantId =
      variantInput?.value ||
      new URLSearchParams(window.location.search).get('variant');

    return (
      getVariantById(root, selectedVariantId) ||
      getVariantsForRoot(root)[0] ||
      null
    );
  };

  const updateRoot = (root, passedVariant) => {
    if (!root) return;

    const variant = resolveCurrentVariant(root, passedVariant);
    if (!variant) return;

    const trustTitle = root.querySelector('.trust-title-new');
    const trustSubtitleText = root.querySelector('.trust-subtitle-text');
    const skuDisplay = root.querySelector(`#pdp-sku-${root.dataset.section}`);

    if (variant.price >= FREE_SHIPPING_THRESHOLD_CENTS) {
      if (trustTitle) trustTitle.textContent = 'This Item Qualifies for Free Shipping';
      if (trustSubtitleText) trustSubtitleText.textContent = 'No extra shipping costs';
    } else {
      if (trustTitle) trustTitle.textContent = 'Free Shipping on Orders $50+';
      if (trustSubtitleText) trustSubtitleText.textContent = 'Fast delivery across US';
    }

    if (skuDisplay) {
      skuDisplay.textContent = 'SKU: ' + (variant.sku || 'GENERIC-SKU');
    }
  };

  const updateAll = () => {
    document
      .querySelectorAll('product-info[id^="MainProduct-"]')
      .forEach((root) => updateRoot(root));
  };

  const updateFromEventDetail = (detail) => {
    const root =
      detail?.productEl?.closest?.('product-info[id^="MainProduct-"]') ||
      (detail?.sectionId
        ? document.querySelector(
            `product-info[id^="MainProduct-"][data-section="${detail.sectionId}"]`
          )
        : null);

    if (root) {
      updateRoot(root, detail.variant || detail.selectedVariant || null);
      return;
    }

    updateAll();
  };

  const updateFromEventTarget = (target) => {
    const root =
      target?.closest?.('product-info[id^="MainProduct-"]') ||
      target?.querySelector?.('product-info[id^="MainProduct-"]') ||
      null;

    if (root) {
      updateRoot(root);
      return;
    }

    updateAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }

  document.addEventListener('product-info:loaded', (event) => {
    updateFromEventTarget(event.target);
  });
  document.addEventListener('shopify:section:load', (event) => {
    updateFromEventTarget(event.target);
  });
  document.addEventListener('variant:changed', (event) => {
    updateFromEventDetail(event.detail || {});
  });
  document.addEventListener('variantChange', (event) => {
    updateFromEventDetail(event.detail || {});
  });
})();
